'use strict';

import React from 'react'

import { handleChange } from '@/Form/Functions/eventsHandling'

import FormElement from '@/Form/toolkit/FormElement'
import Form        from '@/Form/toolkit/Form'
import Loader      from '@Pure/Loader'
import Link        from '@Pure/Link'

export default class PasswordRecoveryForm extends React.Component
{
	constructor (props)
	{
		super();

		this.state = { form_data: { } };

		this.handleChange   = handleChange.bind(this);
		this.handleValidate = this.handleValidate.bind(this);
		this.handleSubmit   = this.handleSubmit.bind(this);
		this.handleFailure  = this.handleFailure.bind(this);
	}

	handleFailure (response)
	{
		const component = this, props = this.props;

		let status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		component.setState(
		{
			error: response.error,
			warning: response.warning,
			status_messages: status_messages,
			loading: false
		});
	}

	handleSubmit ()
	{
		const component = this, props = this.props;

		component.setState({ loading: true });
	}

	handleValidate (response)
	{
		const component = this, props = this.props, state = this.state;

		let form_data = this.state.form_data, status_messages;

		status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		Object.keys(form_data).forEach(function (field, index)
		{
			if (Boolean(form_data[field]) === form_data[field])
			{
				form_data[field] = false;
			}
			else
			{
				form_data[field] = '';
			}
		});

		component.setState(
		{
			error: response.error,
			warning: response.warning,
			info: response.info,
			loading: false,
			form_data: form_data,
			status_messages: status_messages
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let status_message;

		let hide_submit = this.state.sent_to ? true : false;

		let form_data = component.state.form_data, loader;

		let form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

		form_status.forEach(function (status, index)
		{
			if (typeof component.state[status.label] !== 'undefined')
			{
				status_message =
				(
					<div className={ 'c-form-message ' +
						'c-form-message' + status.suffix }>
						<div className="c-form-message__content">
							{ component.state[status.label] }
						</div>
					</div>
				);
			}
		});

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
			);
		}

		let submit =
		(
			<div className="c-btn-container c-btn-container--form u-margin-bottom-15">
				<button type="submit" className="c-btn c-btn--primary c-btn--extra"
					onClick={ function (e) { e.target.blur(); } }>
					Valider
					{ loader }
				</button>
			</div>
		);

		let email_input =
		(
			<FormElement type="email" name="user[login]" label="E-mail"
				id_prefix="recovery-form-" data={ form_data }
				onChange={ component.handleChange }
				status={ component.state.status_messages }/>
		);

		if (this.state.sent_to)
		{
			status_message =
			(
				<div className="c-message c-message--green">
					<div className="c-message__content">
						Un e-mail comportant un lien pour définir un nouveau mot de passe vient de vous être envoyé à l'adresse
						<strong> { this.state.sent_to }.</strong>
					</div>
				</div>
			);

			submit = undefined;
			email_input = undefined;
		}

		var output =
		(
			<Form className={ props.className + ' form-registration' }
				action="/mot-de-passe-oublie"
				data={ form_data }
				onError={ component.handleFailure }
				onValidate={ component.handleValidate }
				onSubmit={ component.handleSubmit }
				history={ props.history }
				hide_button={ true }>

				<div className="home-tabs">
					<div className="c-tab c-tab--active" style={ { width: '100%' } }>
						<h2 className="c-tab__label">Mot de passe oublié</h2>
					</div>
				</div>

				<div className="form-registration__content">

					<div className="o-content">

						{ email_input }

					</div>

				</div>

				<FormElement type="hidden" name="token" id_prefix="registration-form-"
					data={ form_data } />

				<div className="o-content">
					{ status_message }

					{ submit }
				</div> { /* /o-content */ }

			</Form>

		);

		return output;
	}
}